<template>
  <div></div>
</template>

<script>
import axios from "axios";
import { mapMutations } from "vuex";
import { loginController } from "@/api/activityController";
export default {
  name: "refresh",
  data() {
    return {};
  },
  methods: {
    ...mapMutations({
      editPointUserInfo: "POINTUSERINFO",
    }),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      var token = vm.$route.query.token;
      console.log("toke:", token);
      var url = vm.$route.query.url;
      var activityType = vm.$route.query.activityType
      if(url){
        if(activityType){
          window.location = "/jd-hd-web/login-from-old?token=" + token + '&url=' + url + '&activityType=' + activityType;
        }else{
          window.location = "/jd-hd-web/login-from-old?token=" + token + '&url=' + url;
        }
      }else{
        window.location = "/jd-hd-web/login-from-old?token=" + token 
      }
      
    })
  }
};
</script>
<style scoped></style>
